import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Pagination, Form } from 'react-bootstrap';
import Service from 'assets/icon/appwizard_list.png';
import Footer from 'Components/Footer';
import { LinkContainer } from 'react-router-bootstrap';

import { useHistory, Link } from 'react-router-dom';
import TabsIcon from 'MiddleSystems/Components/layout/TabsIcon';
import GroupButtonStock from 'MiddleSystems/Components/layout/GroupButtonStock';
import Return from 'assets/icon/return-value.png';
import Back from 'assets/icon/back.png';
import Select, { components } from 'react-select';

import MyPagination from 'Components/MyPagination'

import Search from 'assets/icon/search.png';
import View from 'assets/icon/view-data.png';
import { useDispatch } from 'react-redux';

//API
import {OrderList,UpdateOrder} from 'actions/orders'
import { loadAuth } from 'actions/auth';
import dayjs from 'dayjs';

export default function Index() {
  const history = useHistory();
  const dispatch = useDispatch();

  const levelString = localStorage.getItem('level');
  const level =JSON.parse(levelString);

  const [statepage, setStatepage] = useState('');

  const [Pages, setPage] = useState([
    { value: '0', label: 'ทั้งหมด' },
    { value: '10', label: '10' },
    { value: '15', label: '15' },
  ]);

  const [ClearSearch, setClearSearch] = useState(false);
  const resetSearch = () => {
    setSearch({ ...search, 
      Keyword: '',
      Status: '',
      PerPage: 10,
      CurrentPage: 1,
      Rows: 0,
      middle: false, 
    })

    setClearSearch(true)
  }

  const toOrderDetail = (item) =>{
    item.status === 'delivery' || item.status === 'done'  ? history.push( `/stock/request-order/${item.id}`)
    : history.push(`/stock/request-order/status/${item.id}`) 

  }

  const convertStatusText = (status) => {
    switch (status){
      case 'pending' : return (<font className="text-light">รออนุมัติ</font>)
      case 'approved' : return (<font className="text-light">อนุมัติ</font>)
      case 'rejected' : return (<font className="text-light">ยกเลิก</font>)
      case 'delivery' : return (<font className="text-dark">จัดส่ง</font>)
      case 'done' : return (<font className="text-light">เสร็จสิ้น</font>)

    }
  }

  const rejectedOrder = async(id) => {
    const formData = {
      id: id,
      data: {
        status: 'rejected'
      }
    }
    try {
      const response = await dispatch(UpdateOrder(formData));
        // history.push('/stock/receipt-order');
        
    } catch (error) {
      console.error(error);
     
    } finally {
      console.log('finally')
    }
  }

  const getAuth = async () => {
    try {
      const params = {
        name: ['ลงชื่อ/รับเข้า(stock)'],
        permission : 'view',
      }
      const response = await dispatch(loadAuth(params));
      if(response.data.data === 'Unauthorized'){
        alert(response.data.message)
        history.push('/stock');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [search, setSearch] = useState({
    Keyword: '',
    Status: '',
    PerPage: 10,
    CurrentPage: 1,
    Rows: 0,
    middle: false, 
  });

  useEffect(() => {
    if (!ClearSearch) getOrders();
    setClearSearch(false)
    getAuth()
  }, [search.PerPage, search.CurrentPage, ClearSearch]);

  const handleSelectPage = (e) => setStatepage(e);

  function closePage() {
    let path = `/stock`;
    history.push(path);
  }

  
  // const [Pages, setPages] = useState([
  //   { value: null, label: 'ทั้งหมด' },
  //   { value: '10', label: '10' },
  //   { value: '15', label: '15' },
  // ]);
  const [type, setType] = useState('');
  const [category, setCategory] = useState('');
  const [button_Search, setButton_Search] = useState('');
  const handleSelectType = (e) => setType(e);
  const handleSelectCategory = (e) => setCategory(e);

  const [display, setDisplay] = useState([
    {
      value: '',
      label: 'ทั้งหมด',
    },
    {
      value: 'delivery',
      label: 'รอรับเข้า',
    },
    {
      value: 'pending',
      label: 'รออนุมัติ',
    },
    {
      value: 'approved',
      label: 'รับเข้า',
    },
    {
      value: 'rejected',
      label: 'ยกเลิก',
    },
    {
      value: 'done',
      label: 'สำเร็จ',
    },
  ]);
  // const [data, setData] = useState([
  //   {
  //     idbuy: 'PO2021070001',
  //     idadmit: 'PU2021070005',
  //     date: '11/06/2564',
  //     partner: 'รุ่งเรืองฟิล์ม',
  //     exampleMenu: 'ฟิล์มติดระจก(ดำ100%)',
  //     priceall: '100,000',
  //     personmenu: 'อวิกา ศรีโพธิ์ทอง',
  //     status: 'รออนุมัติ',
  //   },
  //   {
  //     idbuy: 'PO2021070001',
  //     idadmit: 'PU2021070005',
  //     date: '11/06/2564',
  //     partner: 'รุ่งเรืองฟิล์ม',
  //     exampleMenu: 'ฟิล์มติดระจก(ดำ100%)',
  //     priceall: '100,000',
  //     personmenu: 'อวิกา ศรีโพธิ์ทอง',
  //     status: 'อนุมัติ',
  //   },
  // ]);

  const [orders,setOrders] = useState([]);

  const [isLoading,setIsLoading] = useState(true)

  const getOrders = async() => {
  
      setIsLoading(true)
      try {
        const params = {
          limit: search.PerPage,
          page: search.Keyword === '' ? search.CurrentPage : 1,
          keyworld: search.Keyword,
          status: search.Status,
          middle: false, 
          // use_type: 'order_stock',
          orderBy: 'DESC'
        }
        const response = await dispatch(OrderList(params));
        
        if(search.PerPage > 0){
          setOrders(response.data.data.data);
          setSearch({ ...search, 
            Rows: response.data.data.last_page,
            CurrentPage: response.data.data.current_page 
          })
          setIsLoading(false)
        }else{
          setOrders(response.data.data);
          setSearch({ ...search, 
            Rows: 0,
            CurrentPage: 1 
          })
          setIsLoading(false)
        }
       
      } catch (error) {
        console.error(error);
        
      } finally {
        console.log('finally')
        setIsLoading(false)
      }

  }
  const reset_value = () => {
    setSearch('');
  };
  return (
    <>
      <Container fluid className="package-container Service Stock bg-mrk">
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b><Link to={`/stock`} className='mr-2'>Stock</Link> &gt; คำร้องสั่งสินค้า</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePage}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePage}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b><Link to={`/stock`} className='mr-2'>Stock</Link> &gt; คำร้องสั่งสินค้า</b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0">
                  <Col
                    lg={4}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="ค้นหาด้วยรหัสสินค้า,ประเภท,หมวดหมู่"
                      // defaultValue={statepage[0]}
                      value={search.Keyword}
                      onChange={(e) => setSearch({...search, Keyword: e.target.value})}
                      className="input"
                    ></Form.Control>
                  </Col>
                  <Col
                    xs={6}
                    sm={6}
                    md={4}
                    lg={2}
                    xl={2}
                    className=" mt-2 mb-2"
                  >
                    <Select
                      className=""
                      aria-label="Default select example"
                      placeholder="ทั้งหมด"
                      options={display}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={search.Status ? display.find((data) => {return data.value === search.Status}) : null}
                      onChange={
                        (e) => setSearch({...search, Status: e.value })
                      }
                      
                    />
                  </Col>

                  <Col
                    xs={6}
                    sm={6}
                    md={4}
                    lg={2}
                    xl={2}
                    className=" mt-2 mb-2"
                  >
                    <Button className="button-menu" onClick={getOrders}>
                      <Row className="justify-content-center align-items-center">
                        <Col className="p-0 d-flex justify-content-end">
                          <img src={Search} />
                        </Col>
                        <Col className="p-0 d-flex justify-content-start">
                          <p>ค้นหา</p>
                        </Col>
                      </Row>
                    </Button>
                  </Col>
                  <Col
                    xs={6}
                    sm={6}
                    md={4}
                    lg={2}
                    xl={2}
                    className="d-flex justify-content-center mt-2 mb-2"
                  >
                    <Button className="button-menu" onClick={resetSearch}>
                      <Row className="justify-content-center align-items-center">
                        <Col className="p-0 d-flex justify-content-center">
                          <span>
                            <img src={Return} /> คืนค่า
                          </span>
                        </Col>
                      </Row>
                    </Button>
                  </Col>
                </Row>
                {/* <Row className="g-0 justify-content-center">
                  <GroupButtonStock />
                </Row> */}
                <Row className="g-0 justify-content-center m-0">
                  <Col
                    className=" mt-3 p-0"
                    style={{ overflow: 'scroll', height: '700px' }}
                  >
                    <table className="table table-responsive table-wash-part ">
                      <thead>
                        <tr className="t-header-package">
                          <th>เลขที่สั่งซื้อ</th>
                          <th>สาขา</th>
                          <th>วันที่</th>
                          {/* <th>คู่ค้า</th> */}
                          <th>รายการตัวอย่าง</th>
                          {/* <th>ราคารวม</th> */}
                          <th>ผู้ทำรายการ</th>
                          <th>สถานะ</th>
                        </tr>
                      </thead>
                      <tbody className="t-body-package ">
                        {orders.map((item, i) => {
                          return (
                              <tr key={i} >
                                <td onClick={() => {toOrderDetail(item)}}>{item.middle === true ? item.order_number : item.stock_code}</td>
                                <td onClick={() => {toOrderDetail(item)}}>{item.branche && item.branche.name}</td>
                                <td onClick={() => {toOrderDetail(item)}}>{dayjs(item.order_date).format('DD-MM-YYYY')}</td>
                                {/* <td onClick={() => {toOrderDetail(item)}}>{item.partner && item.partner.company_name}</td> */}
                                <td onClick={() => {toOrderDetail(item)}}>{item.order_detail_example && item.order_detail_example.name}</td>
                                <td onClick={() => {toOrderDetail(item)}}>{item.employee && item.employee.fullname}</td>
                                {
                                  level.middle === true ? (
                                    <td className={item.status == 'pending' ? 'bg-danger' : item.status == 'approved' ? 'bg-primary' : item.status == 'rejected' ? 'bg-dark' : item.status == 'done' ? 'bg-success' : item.status == 'delivery' ? 'bg-warning' : ''} onClick={() => {toOrderDetail(item)}}>{convertStatusText(item.status)}</td>
                                  ) : 
                                    <td onClick={() => {toOrderDetail(item)}}>{convertStatusText(item.status)}</td>
                                }
                                <td >
                                  <Button
                                    type="button"
                                    className="button-package"
                                    // onClick={() => {rejectedOrder(item.id)}}
                                    // disabled={item.status === 'done' || item.status === 'rejected'}
                                    onClick={() => {toOrderDetail(item)}}
                                  >
                                    <img src={View} />
                                  </Button>
                                </td>
                              </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Col>
                </Row>
                <Row className="g-0 pt-5 mt-3 mb-3">
                  <Col lg={5} className=" set-page">
                    <Row>
                      <Col className="d-flex justify-content-center align-items-center">
                        <p style={{ margin: 0 }}>แสดง</p>
                      </Col>
                      <Col lg={7}>
                        <Select
                          className="text-left select-style select-list"
                          aria-label="Default select example"
                          options={Pages}
                          onChange={(data) => setSearch({ ...search, PerPage: data.value })}
                          defaultValue={{ value: 10, label: '10' }}
                        />
                      </Col>
                      <Col className="d-flex justify-content-center align-items-center">
                        <p style={{ margin: 0 }}>รายการ</p>
                      </Col>
                    </Row>
                  </Col>

                  <Col className="d-flex justify-content-end set-paginate">
                  <div className="box-paginate">
                      {/* {
                        !isLoading ? <MyPagination totPages={search.Rows} currentPage={search.CurrentPage} pageClicked={(e) => { setSearch({...search, CurrentPage: e }) }}></MyPagination> : ''
                      } */}
                      {
                        !isLoading ? 
                          search.Rows > 1 && search.PerPage > 0 ?
                            <MyPagination totPages={search.Rows} currentPage={search.CurrentPage} pageClicked={(e) => { setSearch({...search, CurrentPage: e }) }}></MyPagination> 
                          : ''
                        : 
                          search.Rows > 1 && search.PerPage > 0 ?
                            <MyPagination totPages={search.Rows} currentPage={search.CurrentPage} pageClicked={(e) => { setSearch({...search, CurrentPage: e }) }}></MyPagination> 
                          : ''
                      }
                    </div>
                  </Col>
                </Row>   
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
